// Single source of truth for "is this the real, indexable production domain."
// NEXT_PUBLIC_SITE_URL is deliberately left unset on every environment except the final
// production deploy on the client's real domain -- Firebase App Hosting's default *.web.app
// preview URL, and any local/dev environment, must never get indexed. Setting this env var is
// the explicit, deploy-time switch that turns indexing on; there's no domain to guess at yet
// (risks-assumptions-blockers.md B5), so this can't be inferred automatically.
export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "http://localhost:3000";
export const isLive = Boolean(process.env.NEXT_PUBLIC_SITE_URL);

// Firebase serves this same build on the real domain AND on *.web.app/*.firebaseapp.com --
// isLive alone can't tell those apart (it's one build-time flag), so robots.ts additionally
// checks the actual request Host header against this list before allowing crawling. Derived
// from siteUrl rather than hardcoded so this can't drift out of sync with it.
const siteHostname = (() => {
  try {
    return new URL(siteUrl).hostname;
  } catch {
    return null;
  }
})();
export const indexableHostnames = siteHostname
  ? [siteHostname, siteHostname.startsWith("www.") ? siteHostname.slice(4) : `www.${siteHostname}`]
  : [];

// The number the floating WhatsApp chat button (see WhatsAppButton.tsx) opens a chat with --
// this is the same WhatsApp Business number the bot (functions/src/webhooks/whatsapp.ts)
// answers on, so a message sent from the button lands in the same inbox/automation as any
// other WhatsApp contact. Digits only, country code first, no "+" or spaces -- wa.me's own
// URL format. Overridable via env if the business number ever changes without a code change.
export const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? "917389402869";
